import React from 'react';
import Button from '../components/Button';
import Card from '../components/Card';
import CustomerCard from '../components/CustomerCard';
import LabelText from '../components/LabelText';
import Layout from '../components/layout/Layout';
import SplitSection from '../components/SplitSection';
import StatsBox from '../components/StatsBox';
import customerData from '../data/customer-data';
import HeroImage from '../svg/HeroImage';
import SvgCharts from '../svg/SvgCharts';
import background from '../images/bg2.jpg';
import blockchain from '../images/blockchain.webp';
import road_image from '../images/road_image.jpg';
import survey_image from '../images/survey_image.jpeg';
import urban_planning_image from '../images/urban_panning_image.jpg';
import overall_background from '../images/overall_background.jpg';
import home from '../images/home.png';
import phone from '../images/phone.png';
import mail from '../images/mail.png';
import linkedin from '../images/linkedin.png';
import twitter from '../images/twitter.png';
import director from '../images/director.jpg';



const myStyle = {
  backgroundImage: `url(${background})`,
  // backgroundRepeat:'no-repeat',
  // backgroundSize:'contain',
  // backgroundPosition:'center',
}

const globalBg = {
  backgroundImage: `url(${overall_background})`,
}

const serviceImgStyle = {
  height: '346px',
  width: '576px'
}

const Index = () => (

  <Layout>
    <section id="title" className="pt-20 md:pt-40 pb-40" style={myStyle}>
      <div className="container mx-auto px-8 lg:flex">
        <div className="text-center lg:text-left lg:w-1/2">
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-none text-white">
            Bringing Technology To You
          </h1>
        </div>

      </div>
    </section>

  <div style={globalBg}>
    <div class="background">
      <span id="services" class="block  text-dark text-center mb-10 pt-20 text-2xl uppercase font-bold text-5xl">Our Services</span>

      <SplitSection

        primarySlot={
          <div className="lg:pr-32 xl:pr-12">

            <h3 className="text-3xl font-semibold leading-tight">Survey and Monitoring</h3>
            <p className="mt-8 text-l font-normal leading-relaxed">
            <ul class="a">
              <li>State-of-the-art GIS & RS capabilities</li>
              <li>Agile and precise survey through UAV/Drone + DGPS</li>
              <li>Terrain Mapping and alignment fixation through LiDAR</li>
              <li>Bathymetry surveys through Sonar</li>
              <li>Multispectral remote sensing
                <div >
                  <ul class="b">
                    <li>Crop health monitoring</li>
                    <li>Anti-poaching</li>
                    <li>Thermal imagery</li>
                    <li>Progress monitoring</li>
                    <li>Incidence investigation</li>
                  </ul>
                </div>
              </li>
              </ul>

            </p>
          </div>
        }
        secondarySlot={<img src={survey_image} style={serviceImgStyle}/>}
      />
      <SplitSection
        reverseOrder
        primarySlot={
          <div className="lg:pl-32 xl:pl-12">
            <h3 className="text-3xl font-semibold leading-tight">
              Transport and Road Safety
            </h3>
            <p className="mt-8 text-l font-normal leading-relaxed">
              <ul class="a">
                <li>Active Mobility and NMT</li>
                <li>ZEV and E-Mobility</li>
                <li>Mobility as a service (MaaS)</li>
                <li>Tactical urbanism and School zone safety</li>
                <li>Intersection improvements</li>
                <li>Logistics and supply chain</li>
                <li>Multimodal integration and circulation plans</li>
              </ul>
            </p>
          </div>
        }
        secondarySlot={<img src={road_image} style={serviceImgStyle}/>}
      />
      <SplitSection
        primarySlot={
          <div className="lg:pr-32 xl:pr-12">
            <h3 className="text-3xl font-semibold leading-tight">
              Urban, Regional and Environment Planning
            </h3>
            <p className="mt-8 text-l font-normal leading-relaxed">
              <ul class="a">
                <li>Constituency development plans</li>
                <li>Tourism master plans</li>
                <li>EIA, risk assessment and disaster mitigation</li>
                <li>Flood modeling and flood risk resiliency</li>
                <li>Site layouts and master plans</li>
                <li>Urban Analytics</li>
              </ul>
            </p>
          </div>
        }

        secondarySlot={<img src={urban_planning_image} style={serviceImgStyle}/>}
      // secondarySlot={<SvgCharts />}
      />

    </div>

    <section id="aboutus" className="container mx-auto my-20 rounded-lg text-center">

      <div class="p-8 bg-white dark:bg-gray-800 rounded-lg shadow">
        <span class="block  text-dark text-center mb-10 text-2xl uppercase font-bold text-5xl">
          About Us
        </span>
        <h3 class="text-center mb-12 text-xl font-semibold">WE ARE A STARTUP BUILT ON THE PILLARS OF SUSTAINABILITY, SYNERGY AND INTEGRITY.</h3>
        <span class="block  text-dark text-center mb-5 text-2xl uppercase font-semibold text-3xl">
          Our Purpose
        </span>
        <p class="text-center mb-12 text-xl font-semibold">
          Help create distinctive and crucial transformation towards a sustainable world.
        </p>
        <div class="flex flex-col md:flex-row justify-center"></div>
        <p class="text-center mb-12 text-xl font-normal">
          We are a team of high-performing and capable individuals with versatile backgrounds, dedicated to a common purpose. 
          We are supported by associates and advisors from various fields including academia, research, industry and top consultancies.
        </p>
        <div class="flex flex-col md:flex-row justify-center">

          <div class="p-4 bg-white">
            <div class="text-center mb-4 opacity-90">
              <a href="#" class="block relative">
                <img alt="director_profile" src={director} class="mx-auto object-cover rounded-full h-40 w-40 " />
              </a>
            </div>
            <div class="text-center">
              <p class="text-2xl font-bold">
                Abhijith P A
              </p>
              <p class="text-xl font-semibold">
                Director
              </p>
              {/* <p class="text-md max-w-xs py-4 font-normal">
                Thierry Halliday, born November 4, 1993 in Saint hilaire de riez, is css specialist.
              </p> */}
            </div>

          </div>
        </div>
      </div>

    </section>


    {/* Contact Us  */}
    <section id="contactus" class="container  mx-auto rounded-lg">
      <div class="p-8 bg-white dark:bg-gray-800 rounded-lg shadow">
        <div class="flex flex-wrap lg:justify-center -mx-4">
          <div class="w-full lg:w-1/2 xl:w-6/12 px-4">
            <div class=" mb-12 lg:mb-0">
              <span class="block  text-dark text-center mb-20 text-2xl uppercase font-bold text-5xl">
                Contact Us
              </span>
              <p
                class="text-base text-1xl text-primary font-semibold"
              >
                GET IN TOUCH WITH US
              </p>

              <div class="flex mt-8 mb-8 max-w-[370px] w-full">
                <div
                  class="
                     max-w-[60px]
                     sm:max-w-[70px]
                     h-[60px]
                     sm:h-[70px]
                     flex
                     items-center
                     justify-center
                     mr-6
                     overflow-hidden
                      bg-opacity-5
                     text-primary
                     rounded
                     "
                >
                  <img src={home} />
                </div>
                <div class="w-full">
                  <h4 class="font-bold text-dark text-xl mb-1">Our Location</h4>
                  <p class="text-base text-body-color">
                    #4A, NITK Step Cell, NITK Surathkal - 575025
                  </p>
                </div>
              </div>
              <div class="flex mb-8 max-w-[370px] w-full">
                <div
                  class="
                     max-w-[60px]
                     sm:max-w-[70px]
                     h-[60px]
                     sm:h-[70px]
                     flex
                     items-center
                     justify-center
                     mr-6
                     overflow-hidden
                      bg-opacity-5
                     text-primary
                     rounded
                     "
                >
                  <img src={phone} />
                </div>
                <div class="w-full">
                  <h4 class="font-bold text-dark text-xl mb-1">Phone Number</h4>
                  <p class="text-base text-body-color">(+91) 9535295777</p>
                </div>
              </div>
              <div class="flex mb-8 max-w-[370px] w-full">
                <div
                  class="
                      max-w-[60px]
                      sm:max-w-[70px]
                      h-[60px]
                      sm:h-[70px]
                      flex
                      items-center
                      justify-center
                      mr-6
                      overflow-hidden
                       bg-opacity-5
                      text-primary
                      rounded
                      "
                >
                  <img src={mail} />
                </div>
                <div class="w-full">
                  <h4 class="font-bold text-dark text-xl mb-1">
                    Email Address
                  </h4>
                  <p class="text-base text-body-color">office@techmillennials.in</p>
                </div>

              </div>

              <div class="flex mw-50">
                <div class="flex">
                  {/* LINKED IN REDIRECTION LINK */}
                  <a href='https://www.linkedin.com/company/tech-millennials'>
                    <img src={linkedin} />
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
    </div>







  </Layout>
);

export default Index;
